import Vue from 'vue'
import App from './App'
import {delCookie, getCookie, setCookie} from './utils/cookies'
import Router from './router'
import Store from './store'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import varGlobal,
{getApiDomainName, isNullOrUndefined, isPhone,ParseJwtToken,isLogin,noLoginAndRouter,noLoginToLogin,routerPushMustGo} from './utils/common'
import {filepost, get, post} from "./utils/axios";
import Agreement from "./utils/agreement";

Vue.config.productionTip = false

Vue.prototype.$getApiDomainName = getApiDomainName
Vue.prototype.$isNullOrUndefined = isNullOrUndefined
Vue.prototype.$isPhone = isPhone
Vue.prototype.$jwtToken = ParseJwtToken
Vue.prototype.$isLogin = isLogin
Vue.prototype.$noLoginAndRouter = noLoginAndRouter
Vue.prototype.$noLoginToLogin = noLoginToLogin
Vue.prototype.$routerPushMustGo = routerPushMustGo
Vue.prototype.$getCookie = getCookie
Vue.prototype.$setCookie = setCookie
Vue.prototype.$removeCookie = delCookie
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$filepost = filepost
Vue.prototype.$suffix = varGlobal.pageTitle
Vue.prototype.$re_treaty = Agreement.Registration_Agreement
Vue.prototype.$pr_treaty = Agreement.Privacy_Agreement

Vue.use(Element)

new Vue({
    render: h => h(App),
    store: Store,
    router: Router,
}).$mount('#app')
